module.exports = __webpack_public_path__ + "img/logo-eccovia-black-full.c1a98bfb.png";